/**
 * http://usejsdoc.org/
 */
/**
 * http://usejsdoc.org/
 */
import React, { Component } from 'react';

import {
	Card, CardImg, CardText, CardBody,
	CardTitle, Breadcrumb, BreadcrumbItem, Button, Modal, ModalHeader, ModalBody, Col, Row, Label
} from 'reactstrap';
import { Control, LocalForm, Errors } from 'react-redux-form';
import jumpersStore from '../../../stores/jumpers-store';
import Select, { components } from 'react-select';
import CreatableSelect from 'react-select/lib/Creatable';
import loadsStore from '../../../stores/loads-store';
import JmpModal from './customModal';

class CreatableJumper extends Component {

	constructor(props) {

		super(props);
		//this.toggleModal = this.toggleModal.bind(this);
		//this.handleSubmit = this.handleSubmit.bind(this);

		this.state = {
			isModalOpen: false,
			jumpType: null,
			load: props.load,
			jumper: props.jumper,
			type: props.type,
			label: props.type,
			jumpId: props.jumpId,
			editMode: props.editMode,
			selectedStudent: undefined,
			options: props.options,
			elementWidth: props.elementWidth
		};
		this.gearIds = [];
		this.valRef = null;
		this.inputValue = '';
	}

	componentDidMount = () => {
		//console.log('in component did mount editable jumper');
		//console.log(this.valRef);
		if (this.valRef !== null)
			this.valRef.focus();

		this.handleStudentsLoaded()

	}

	componentDidUpdate = () => {
		//console.log('in component did update editable jumper');
		//console.log(this.valRef);
		if (this.valRef !== null)
			this.valRef.focus();
	}

	handleStudentsLoaded = () => {
		console.log('handleAffStudentsLoaded')
		if (this.props.type === "aff") {
			this.setState({
				options: jumpersStore.getAffStudentOptions().filter(
					option =>
						this.props.activeJumperIdsOnLoad.findIndex(
							id => option.value._id === id
						) === -1
				)
			});
		}
		else if (this.props.type === "tandem") {
			this.setState({
				options: jumpersStore.getTandemStudentOptions()
			});
		}

	}

	Option = (props) => {
		var gearModel = ".gear" + props.data.value._id;
		var name = "gear" + props.data.value._id
		return (
			<div className="row">
				<div className="col-8">
					<components.Option {...props} />
				</div>
				<div className="col-4" style={{ paddingTop: '6px' }}>
					gear <Control.checkbox model={gearModel} name={name} onChange={value => { this.updateGear(value) }} />
				</div>
			</div>
		);
	}

	SingleValueLabel = ({ children, ...props }) => {
		//console.log(props);
		//console.log(props.data);
		//console.log(components.SingleValue);
		return (
			<components.SingleValue {...props}><div className="row"> <div className="col-8">{children}</div>{this.gearIds.indexOf(props.data.value._id) > -1 ? <div className="col-4">-G</div> : null}</div></components.SingleValue>
			//{this.gearIds.indexOf(props.data.value._id)>-1?<div className="col-4">-G</div>:null }
		);
	}


	handleChange = (selectedOption, loadNum, jumpId, type, label) => {
		//alert(JSON.stringify(selectedOption));
		var jumpPostBody = { studentId: selectedOption.value };
		if (type === "tandem") {
			var jumpPostBody = { studentId: selectedOption.value };
			loadsStore.updateTandemJump(loadNum, jumpId, jumpPostBody);
		}
		else if (type === "aff") {
			var jumpPostBody = { studentId: selectedOption.value._id };
			loadsStore.updateAffJump(loadNum, jumpId, jumpPostBody);
		}
		this.setState({ editMode: false })
	}

	changeJumper = () => {
		////alert('change jumper');
		//console.log(this.valRef);
		this.setState({
			editMode: !this.state.editMode
		})
	}

	filterJumpers = (inputValue: string, jumperOptions) => {
		//console.log("in filterJumpers");
		if (inputValue) {
			//console.log(inputValue);
			/*
			var filteredOptions = jumperOptions.filter(i =>
					  i.label.toLowerCase().match(inputValue.toLowerCase()));*/
			//console.log('before useing fuse');
			var test = jumpersStore.test();
			var filteredOptions = jumpersStore.searchJumperOptionsUsingFuse(inputValue.toLowerCase());
			////alert('after fuse');
			//console.log(filteredOptions);
			if (filteredOptions.length > 30) return filteredOptions = filteredOptions.slice(0, 30);
			else return filteredOptions;
		}
		return jumperOptions;
	};

	promiseOptions = (inputValue, jumperOptions) => {
		//console.log('in pomiseOptions');
		//console.log(this.state.inputValue);
		return new Promise(resolve => {
			resolve(this.filterJumpers(this.inputValue, jumperOptions));
		});
	}

	handleCreateStudent = (value, loadNum, jumpId, type, label) => {
		////alert(JSON.stringify(value));
		var split = value.split(" ");
		var firstname = split[0];
		var lastname = split[1];
		var payload = { firstname: firstname, lastname: lastname };

		if (type === "tandem") {
			jumpersStore.AddWalkinTandemStudent(payload)
				.then(student => this.handleCreatedStudent(student, loadNum, jumpId, type, label));
		}
		else if (type === "aff") {
			var payload = { firstname: firstname, lastname: lastname };
			payload.ratings = [{ rating: "AFF STUDENT", number: '11111' }];
			alert(JSON.stringify(payload));
			jumpersStore.CreateJumper(payload)
				.then(student => this.handleCreatedStudent(student, loadNum, jumpId, type, label));
		}
		////alert("firstname: " + firstname + " lastname: " + lastname);
	}

	handleCreatedStudent = (student, loadNum, jumpId, type, label) => {

		var studentOption = { label: student.firstname + " " + student.lastname, value: student._id.toString() };
		////alert(JSON.stringify(studentOption))
		var options = this.state.studentOptions;
		////alert(JSON.stringify(this.state.studentOptions));
		if (options.length > 0) {
			this.setState({
				studentOptions: [...options, studentOption]
			});
		}
		else {
			this.setState({
				studentOptions: [studentOption]
			});
		}

		this.handleChange(studentOption, loadNum, jumpId, type, label);
	}

	handleInputChange = (newValue) => {
		//console.log('handleInputChange');

		//const inputValue = newValue.replace(/\W/g, '');
		////console.log(inputValue);

		//this.promiseOptions(newValue, jumperOptions);
		this.inputValue = newValue;
		//clearTimeout(this.timerId);
		//this.timerId = setTimeout(this.cancelOrSubmit, 5000);
		//this.valRef.focus();

		//return inputValue;
	};

	onBlur = () => {
		//alert('blurring');
		this.setState({
			editMode: false
		})
	};
	render() {
		let SelectInput = (props) => (<Select model={props.model} name={props.name} placeholder={props.placeholder} options={props.options} onChange={props.onChange} isMulti={props.isMulti} components={props.components} styles={props.styles} theme={(theme) => ({
			...theme,
			colors: {
				...theme.colors,
				primary: '#E7F2F6',
				// primary75: 'red',
				// primary50: 'blue',
				primary25: 'blue', // hover option
				// danger: 'green',
				dangerLight: '#59C5DC', // cross background
				neutral0: 'rgb(0, 65, 157)', // background container
				// neutral5: 'pink',
				neutral10: 'blue', // selected option background
				neutral20: '#E7F2F6', // border input without hover
				neutral30: '#E7F2F6', // border input with hover
				neutral40: 'orange',
				neutral50: '#E7F2F6', // default text
				neutral60: '#E7F2F6', // down icon
				neutral70: 'yellow',
				neutral80: '#E7F2F6', //selected text color
				// neutral90: 'rgb(0, 65, 157)',
			},
		})} />);

		//console.log(this.props.options);
		//alert('in creatableTandemStudents ' + JSON.stringify(this.props.options))

		//alert('in creatableTandemStudents ' + JSON.stringify(this.state.studentOptions))
		//alert(this.props.disabled);

		var options = this.state.options;
		if (this.state.options && this.props.activeJumperIdsOnLoad) {
			options = options.filter(
				option =>
					this.props.activeJumperIdsOnLoad.findIndex(
						id => option.value._id === id
					) === -1
			);
		}

		return (
			//<button className="btn lightBlueButton jumper-name" onClick = {this.setState({editMode: !this.state.editMode})} type="submit" disabled={this.props.disabled}>

			/*
			{this.state.editMode?
				<Select model=".jumper" name = "jumper" options={this.props.options} onChange={(selectedOption) => this.handleChange(selectedOption, this.state.loadNum, this.state.jumpId, this.state.type, this.state.label)}/>
				:
					<b>{this.state.label}":" </b>
				//<div>{this.state.jumper.firstname} {this.state.jumper.memberId}</div>
			}
			*/
			<React.Fragment>
				{/* <button className="btn lightBlueButton jumper-name" onClick = {this.changeJumper} type="submit" disabled={this.props.disabled}>
            		{!this.state.editMode?
            				<div><b>{this.props.label}</b>{this.props.jumper.firstname} {this.props.jumper.lastname}</div>
            				:
        					<CreatableSelect
        						ref={ (value) => this.valRef=value}
        			        	isClearable
        			        	isDisabled={false}
        			        	isLoading = {false}
        			        	onChange  = {(selectedOption) => this.handleChange(selectedOption, this.props.loadNum, this.props.jumpId, this.props.type, this.props.label)}
        			        	onCreateOption={this.handleCreateTandemJumper}
        			        	options={this.props.options}
            				    menuPortalTarget={document.body}
 						        menuPosition="fixed"
        			        />
            		}
								</button>          */}
				{
					!this.state.editMode ?
						// <button className="btn lightBlueButton jumper-name" onClick={this.changeJumper} type="submit" disabled={this.props.disabled}>
						<div className="name-container tandem-font-size" onClick={this.changeJumper} disabled={this.props.disabled}>
							<div><span className="tandem-font-size">S: </span><strong className="tandem-font-size">{this.props.jumper.firstname} {this.props.jumper.lastname}</strong></div>
						</div>
						:
						// <button className="btn lightBlueButton jumper-name" type="submit" disabled={this.props.disabled} style={{width:'200px'}}>
						// <button className="btn editable-FunJumper" type="submit" disabled={this.props.disabled} style={{padding :'0',bottom:'2px',width:'170px' }}>
						<button className="btn editable-FunJumper" type="submit" disabled={this.props.disabled} style={this.props.elementWidth ? this.props.elementWidth : { width: '170px' }}>

							<CreatableSelect
								ref={(value) => this.valRef = value}
								isClearable
								isDisabled={false}
								isLoading={false}
								onChange={(selectedOption) => this.handleChange(selectedOption, this.props.loadNum, this.props.jumpId, this.props.type, this.props.label)}
								onCreateOption={(value) => this.handleCreateStudent(value, this.props.loadNum, this.props.jumpId, this.props.type, this.props.label)}
								options={options}
								menuPortalTarget={document.body}
								menuPosition="fixed"
								onBlur={this.onBlur}
							/>
						</button>
				}
			</React.Fragment>
		);
	}
}

export default CreatableJumper
